import { useState, useRef, useEffect, useCallback } from "react"
import { TPolicyRenewalsBundle } from "models/policies/policyRenewals"
import useOpus from "contexts/opus/hooks/use-opus"

export const useSetPolicyRenewalsReinstate = (
  policyID: string | undefined,
  successCallback?: () => void
): IUseSetPolicyRenewalsReinstate => {
  const [isSending, setIsSending] = useState(false)
  const [isError, setIsError] = useState(false)
  const [ReinstateResponse, setReinstateResponse] = useState<
    TPolicyRenewalsBundle | undefined
  >(undefined)

  const isMounted = useRef(true)
  const { policyClient } = useOpus()

  useEffect(() => {
    return () => {
      isMounted.current = false
    }
  }, [])

  const sendRequest = useCallback(async () => {
    if (isSending) return

    setIsSending(true)

    try {
      if (policyID) {
        const _Reinstate = await policyClient.setPolicyRenewalReinstate(
          policyID
        )
        setReinstateResponse(_Reinstate)
        successCallback && successCallback()
      }
    } catch (error) {
      setIsError(true)
    }

    setIsSending(false)

    if (isMounted.current) setIsSending(false)
  }, [isSending, policyClient, policyID, successCallback])

  return { response: ReinstateResponse, sendRequest, isSending, isError }
}

interface IUseSetPolicyRenewalsReinstate {
  sendRequest: () => Promise<void>
  response: TPolicyRenewalsBundle | undefined
  isError: boolean
  isSending: boolean
}
